export enum Languages {
  en = 'en-US',
  de = 'de-DE',
  es = 'es-ES',
  fr = 'fr-FR',
  it = 'it-IT',
  nl = 'nl-NL',
  sv = 'sv-SE',
  zh = 'zh-CN',
  pl = 'pl-PL',
  tr = 'tr-TR',
  cs = 'cs-CZ',
  hu = 'hu-HU',
  ko = 'ko-KR',
  pt = 'pt-BR',
  ja = 'ja-JP',
}
